// Core Imports
import { api } from '@/core/lib/api'
import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

// Module Imports
import type {
  TCreateCustomGameModeRequest,
  TCustomGameMode,
  TCustomGameModeListResponse,
  TUpdateCustomGameModeRequest,
} from '@/modules/custom-game-mode/custom-game-mode.types'

const base = '/admin/custom-game-modes'

export async function listCustomGameModes(
  params: TAdminListParams
): Promise<TCustomGameModeListResponse> {
  const response = await api.get<TCustomGameModeListResponse>(
    `${base}?${buildAdminListQuery(params)}`
  )
  return response.data
}

export async function listAllCustomGameModes(): Promise<TCustomGameMode[]> {
  const response = await api.get<TCustomGameMode[]>(`${base}/all`)
  return response.data
}

export async function getCustomGameMode(id: string): Promise<TCustomGameMode> {
  const response = await api.get<TCustomGameMode>(`${base}/${id}`)
  return response.data
}

export async function createCustomGameMode(
  body: TCreateCustomGameModeRequest
): Promise<TCustomGameMode> {
  const response = await api.post<TCustomGameMode>(base, body)
  return response.data
}

export async function updateCustomGameMode(
  id: string,
  body: TUpdateCustomGameModeRequest
): Promise<TCustomGameMode> {
  const response = await api.patch<TCustomGameMode>(`${base}/${id}`, body)
  return response.data
}

export async function deleteCustomGameMode(id: string): Promise<void> {
  await api.delete(`${base}/${id}`)
}
